<template>
  <footer role="contentinfo" class="py-4 lh-1 bg-white">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center text-sm">
          <p class="mb-0">&copy; 2020 -
            <router-link to="/user/landing">
              Scales
            </router-link>.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style />

<script type="text/javascript">
export default {
  data: function () {
    return {
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/user/copyright.vue